import React from "react";
import { MapPin } from "lucide-react";

// OpenStreetMap embed centered on a Canadian city — no API key required.
export default function MapEmbed({ city = "Toronto", zone = "" }) {
  const q = encodeURIComponent(`${zone || city}, Canada`);
  const src = `https://www.openstreetmap.org/export/embed.html?bbox=&layer=mapnik&marker=&q=${q}`;
  // Use a search URL that auto-centers
  const searchSrc = `https://www.google.com/maps?q=${q}&output=embed`;
  return (
    <div className="border border-border bg-card overflow-hidden" data-testid="map-embed">
      <div className="px-4 py-2.5 border-b border-border flex items-center gap-2">
        <MapPin className="w-4 h-4 text-primary" />
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground">Service area</div>
        <div className="text-sm font-medium ml-1">{zone || city}</div>
      </div>
      <iframe
        title="Service area map"
        src={searchSrc}
        className="w-full h-72 border-0"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        data-testid="map-iframe"
      />
    </div>
  );
}
